import React, { useEffect, useState } from 'react';

import { Button, FlexBox } from '@eltoro-ui/components';
import CustomIcons from 'assets/icons';

import CampaignExamplesModal from 'Components/CampaignExamplesWidget/components/CampaignExamplesModal';

import './CampaignExamplesWidget.scss';
import CampaignExamplesMobileModal from 'Components/CampaignExamplesWidget/components/CampaignExamplesModal/CampaignExamplesMobileModal';

interface CampaignExamplesWidgetProps {
  redirectToLens?: boolean;
}

export default function CampaignExamplesWidget({
  redirectToLens = true,
}: CampaignExamplesWidgetProps) {
  const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);
  const [exampleModalOpen, setExampleModalOpen] = useState(false);

  const onSeeCampaignExamples = () => setExampleModalOpen(true);
  const onCancel = () => setExampleModalOpen(false);
  useEffect(() => {
    const handleResize = () => {
      setDeviceWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <FlexBox
      alignItems="center"
      justifyContent="space-between"
      UNSAFE_className="campaign-examples-widget"
      gap="2.5rem"
    >
      <FlexBox alignItems="center" gap="12px" UNSAFE_className="examples-widget-content">
        <CustomIcons name="gift" fontSize={32} />
        <span className="campaign-examples-widget-description">
          View effective campaign examples tailored to each campaign type, aligned with the goal you
          want to achieve.
        </span>
      </FlexBox>
      <Button
        size="l"
        kind="text"
        onClick={onSeeCampaignExamples}
        UNSAFE_className="refresh-contacts"
      >
        See Campaign Examples
      </Button>
      {exampleModalOpen && deviceWidth > 850 ? (
        <CampaignExamplesModal redirectToLens={redirectToLens} onCancel={onCancel} />
      ) : exampleModalOpen && deviceWidth <= 850 ? (
        <CampaignExamplesMobileModal onCancel={onCancel} redirectToLens={redirectToLens} />
      ) : null}
    </FlexBox>
  );
}
